import React from 'react';
import { Box, Fab } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Close } from '@material-ui/icons';


const headerStyles = makeStyles({
    root:{
        backgroundColor: '#E1E1E1',
        color: 'black',
        fontFamily: 'GoBoldThin',
        fontSize: 30,
        textTransform: 'uppercase'
    },
    closeBtn:{        
        width: 24,
        height: 24,
        position: 'absolute',
        top: 8,
        right: 8,
        color: '#333333',
        minHeight:1
    },
    closeIcon:{
        fontSize: 18
    }
});

export default function Header({content, cancelAction, view}){
    const classes = headerStyles();
    return (
        <Box className={classes.root} height={60} display="flex" justifyContent="center" alignItems="center">
            {content}            
        </Box>
    );
}